/* eslint-disable no-useless-escape */
import angular from 'angular';
import template from './createNewCandidateView.html';
import Logger from '../../../shared/logger';

export class CreateNewCandidate {
    /* @ngInject */
    constructor($scope, $state, TalentService, Upload, NotificationService, $localStorage, $stateParams, $filter, EnvSettings) {
        const createCandCtrl = this;
        createCandCtrl.back = () => {
            if ($stateParams.recruiterId) {
                $state.go('recruiter.positions', { recruiterId: $stateParams.recruiterId });
            } else {
                $state.go('talenya.jobs');
            }
        };

        createCandCtrl.uploadFiles = (file) => {
            if (file) {
                file.upload = Upload.upload({
                    url: `${EnvSettings.BackendUrl}/upload/resume`,
                    data: { file },
                    headers: {
                        'on-behalf': JSON.stringify({ recruiterId: $stateParams.recruiterId }),
                    },
                });

                file.upload.then(() => {
                    NotificationService.success('UPLOAD_RESUME_SUCCESS');
                }, () => {
                    NotificationService.error('UPLOAD_RESUME_FAILED');
                }, (evt) => {
                    file.progress = Math.min(100, parseInt(100.0
                        * evt.loaded / evt.total));
                });
            }
        };

        createCandCtrl.uploadCandidate = function (form) {
            if (form.$invalid) {
                return;
            }

            createCandCtrl.badUrl = false;

            const expression = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;
            const regex = new RegExp(expression);
            if (!createCandCtrl.linkedinUrl.match(regex)) {
                createCandCtrl.badUrl = true;
                NotificationService.error($filter('translate')('URL_FORMAT_ERROR'));
                return;
            }

            TalentService.postTalentForCreation({
                candidateUrl: createCandCtrl.linkedinUrl,
            })
                .then((response) => {
                    if (response.message) {
                        NotificationService.error(response.result);
                    } else {
                        createCandCtrl.linkedinUrl = '';
                        NotificationService.success(response.result);
                    }
                }, (err) => {
                    NotificationService.error(err.data.result);
                });
        };

        // upload on file select or drop
        createCandCtrl.upload = function (file) {
            Upload.upload({
                url: 'http://localhost:3000/upload/resume',
                data: { file },
            })
                .then((resp) => {
                    Logger.info(`Success ${resp.config.data.file.name}uploaded. Response: ${resp.data}`);
                }, (resp) => {
                    Logger.error(`Error status: ${resp.status}`);
                }, (evt) => {
                    const progressPercentage = parseInt(100.0 * evt.loaded / evt.total);

                    Logger.info(`progress: ${progressPercentage}% ${evt.config.data.file.name}`);
                }).catch((error) => Logger.error(error));
        };
    }
}

export const CreateNewCandidateConfiguration = {
    template,
    controller: CreateNewCandidate,
    controllerAs: 'createCandCtrl',
};

angular
    .module('TALENYA-FE')
    .component('createNewCandidate', CreateNewCandidateConfiguration);
